import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MessService } from 'src/app/_services/mess-service.service';
import { StatusService } from 'src/app/_services/status.service';

@Component({
  selector: 'app-status-add',
  templateUrl: './status-add.component.html',
})
export class StatusAddComponent implements OnInit, OnDestroy {
  addStatusForm: FormGroup;
  disableSave: boolean = true;
  subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private statusService: StatusService,
    private messService: MessService
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    this.addStatusForm = this.fb.group({
      label: ['', Validators.required],
      name: ['', Validators.required],
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.messService.clearErrors();
  }

  // * Add status === //
  onAddStatus() {
    const status = this.addStatusForm.getRawValue();
    this.subscriptions.push(
      this.statusService.addStatus(status).subscribe(
        () => {
          this.messService.add({
            severity: 'success',
            title: 'Uspešno kreiranje',
            detail: 'Kreirali ste novi status.',
          });
          this.router.navigate(['./../'], { relativeTo: this.route });
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.addStatusForm;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }
}
